import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Button from '../common/ButtonComponent';
import MoveMoneyStore from '../../stores/MoveMoneyStore';
import BrowserUtils from '../../utils/BrowserUtils';
import SavingPotComponent from './SavingPotComponent';
import SavingPotAvailable from './SavingPotAvailable';
import InternetBankingActions from '../../actions/InternetBankingActions';
import SavingsPotsStore from '../../stores/SavingsPotsStore';
import _ from 'lodash';
import StringConstant from '../../constants/StringConstants';
import SavingPotsActionCreator from '../../actions/SavingPotsActionCreator';
import MoveMoneyBL from './MoveMoneyBL';
import SelectedAccountComponent from './SelectedAccountComponent';

import { Panel } from 'react-bootstrap';

class SavingComponent extends React.Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
    this.savingpotClick = this.savingpotClick.bind(this);
    this.getSavingsPots = this.getSavingsPots.bind(this);
    this.continueClick = this.continueClick.bind(this);
    this.onStoreChange = this.onStoreChange.bind(this);
    this.potClick = this.potClick.bind(this);
    this.setAllocatedCheck = this.setAllocatedCheck.bind(this);
    this.potAvailableClick = this.potAvailableClick.bind(this);
    this.checkKeyPress = this.checkKeyPress.bind(this);
    this.tosavingpotClick = this.tosavingpotClick.bind(this);
    this.NavigateToSavingpotClick = this.NavigateToSavingpotClick.bind(this);

    this.isPotDisabled = this.isPotDisabled.bind(this);
    this.state = {
      // New state
      //   isPotOpened: this.props.potOpen,
      fromSelectedPot: this.props.fromSelectedPot,
      fromAvailablePot: this.props.fromAvailablePot,
      toSelectedPot: this.props.toSelectedPot,
      toAvailablePot: '',
      potList: MoveMoneyStore.getPotDetails(this.props.data.id),

      // Not USED
      isRejig: false,
      continueActive: false,
      curAmount: 0.0,
      availAmount: 0.0,
      reee: 'account-card',
      enableContinue: false,
      selectedPotData: '',
      fromAllocatedCheck: false,
      toAllocatedCheck: false,
    };
  }

  onClick() {
    this.props.savingOpened(this.props.data.id);
  }

  onStoreChange() {
    // this.setState({ potList: MoveMoneyStore.getPotDetails(this.props.data.id) });
  }

  getSavingsPots() {}

  setAllocatedCheck() {
    // if (this.state.potList === undefined) {
    //     return;
    // }
    // if (this.props.name !== StringConstant.toList) {
    //     _.map(this.state.potList.pots, check => {
    //         if (check.balance < 0) {
    //             this.setState({ fromAllocatedCheck: true });
    //         } else {
    //             this.setState({ fromAllocatedCheck: false });
    //         }
    //         return false;
    //     });
    // } else {
    //     _.map(this.state.potList.pots, check => {
    //         if (check.balance < 0) {
    //             this.setState({ toAllocatedCheck: true });
    //         } else {
    //             this.setState({ toAllocatedCheck: false });
    //         }
    //         return false;
    //     });
    // }
  }

  NavigateToSavingpotClick(e) {
    if (e.charCode === 13 || e.charCode === 32) {
      this.tosavingpotClick();
    }
  }

  checkKeyPress(e) {
    if (e.which === 40 || e.keyCode === 40) {
      if (document.activeElement.nextSibling) {
        document.activeElement.nextSibling.focus();
      }
    } else if (e.which === 38 || e.keyCode === 38) {
      if (document.activeElement.previousSibling) {
        document.activeElement.previousSibling.focus();
      }
    } else if (e.which === 13 || e.keyCode === 13) {
      this.onClick(e);
      if (e.target.tagName !== 'BUTTON') {
        e.preventDefault();
      }
    }
  }

  checkRegig() {
    let regig;
    _.map(this.state.potList.pots, (check) => {
      if (check.balance < 0) {
        regig = true;
      }
    });
    return regig;
  }

  continueClick() {
    // if (this.state.continueActive === true) {
    //     this.setState({
    //         isRejig: false,
    //     });
    //     if (this.props.name === 'toList') {
    //         MoveMoneyActionCreator.continueClickToPot();
    //         // this.props.savingsToAccFlag(true);
    //     } else {
    //         MoveMoneyActionCreator.continueClickPot();
    //         // this.props.savingsFromAccFlag(true); // TO CHECK
    //     }
    //     this.props.onClick(this.props.data);
    //     // this.props.setfromAccountFlag(); // TO CHECK
    // }
    if (this.props.name === StringConstant.fromList) {
      this.props.onClick(this.props.data, this.state.fromSelectedPot);
    } else {
      this.props.onClick(this.props.data, this.state.toSelectedPot);
    }
  }

  // USE BL methods instead of MoveMoneyStore.IsToAccountSame
  isAccountInActive() {
    if (this.props.name === 'fromList') {
      if (
        MoveMoneyStore.getSpendingFlag() &&
        MoveMoneyStore.IsToAccountSame(this.props.data.id) &&
        MoveMoneyStore.getOneOffPayment().isMonthly
      ) {
        return true;
      }
    }
    return false;
  }

  isFromList() {
    return this.props.name === StringConstant.fromList;
  }

  isPotDisabled(potData) {
    if (this.isFromList()) {
      if (
        (MoveMoneyStore.isOneOffPayment() ||
          !_.isEmpty(MoveMoneyStore.isOnlyMoveMoney())) &&
        !MoveMoneyStore.getOneOffPayment().isMonthly &&
        !_.isEmpty(MoveMoneyStore.getSelectedToAccount()) &&
        this.props.data.id === MoveMoneyStore.getSelectedToAccount().id &&
        potData.id === MoveMoneyStore.getSelectedToPotId()
      ) {
        return true;
      } else if (
        (MoveMoneyStore.isOneOffPayment() ||
          !_.isEmpty(MoveMoneyStore.isOnlyMoveMoney())) &&
        !MoveMoneyStore.getOneOffPayment().isMonthly &&
        !_.isEmpty(MoveMoneyStore.getSelectedToAccount()) &&
        this.props.data.id !== MoveMoneyStore.getSelectedToAccount().id &&
        potData.name !== 'Not in Pot'
      ) {
        return true;
      } else {
        return potData.balance === 0;
      }
    } else {
      const toPotDisable = MoveMoneyBL.toPotDisableConditions(
        this.props.data.id,
        potData,
        this.state.fromSelectedPot.id
      );
      return toPotDisable;
    }
  }

  // Understand total click functionality
  potAvailableClick(data) {
    if (this.isFromList()) {
      this.setState({
        fromAvailablePot: data,
        fromSelectedPot: '',
      });
    } else {
      this.setState({
        toAvailablePot: data,
        toSelectedPot: '',
      });
    }
    // this.setState({ enableContinue: true });
    // if (this.props.name === StringConstant.fromList) {
    //     MoveMoneyActionCreator.savingTotalClick(true);
    // } else {
    //     MoveMoneyActionCreator.toSavingTotalClick(true);
    // }
  }

  potClick(data) {
    if (this.isFromList()) {
      this.setState({
        fromSelectedPot: data,
      });
    } else {
      this.setState({
        toSelectedPot: data,
      });
    }

    // this.setState({ enableContinue: true, selectedPotData: data });
  }

  savingpotClick() {
    // this.setAllocatedCheck();
  }

  showSavingPotPanel() {
    // TODO : Write logic for disable continue button
    // let disabled = true;
    // if (this.props.name === StringConstant.fromList && this.props.potOpen && (MoveMoneyStore.getSavingsPotFromClicked(this.props.data.id) || MoveMoneyStore.enableFromContinue())) {
    //     disabled = false;
    // } else if (this.props.name === StringConstant.toList && this.props.potOpen && (MoveMoneyStore.getSavingsPotToClicked(this.props.data.id) || MoveMoneyStore.enableToContinue())) {
    //     disabled = false;
    // }

    const selectedPot = this.isFromList()
      ? !_.isEmpty(this.state.fromSelectedPot)
        ? this.state.fromSelectedPot
        : this.state.fromAvailablePot
      : this.state.toSelectedPot || this.state.toAvailablePot;
    const disabled = _.isEmpty(selectedPot);
    const isRegig = this.checkRegig();
    return (
      // <Panel collapsible expanded={this.props.potOpen} >
      <Panel collapsible expanded="true">
        <div>
          {isRegig ? (
            <div className="rejig-case">
              <label className="rejig-case__msg">
                {this.props.content.unAllocatedHeader}
              </label>
              <div
                className="c-btn--rejig"
                tabIndex="0"
                onKeyPress={(e) => this.NavigateToSavingpotClick(e)}
                onClick={this.tosavingpotClick}
              >
                Take a closer look to ensure you keep to your pot targets
              </div>
            </div>
          ) : (
            <div>
              <div className="c-radio c-radio__movemoney">
                {this.state.potList !== undefined &&
                  _.map(this.state.potList.pots, (potDetails, i) => {
                    {
                      /* let checked = MoveMoneyStore.getSelectedPotData() !== '' && dData.id === MoveMoneyStore.getSelectedPotData().id; */
                    }
                    let checked =
                      !_.isEmpty(selectedPot) &&
                      selectedPot.id === potDetails.id;
                    let potDisabled = this.isPotDisabled(
                      potDetails,
                      selectedPot
                    );
                    return (
                      <SavingPotComponent
                        key={i}
                        potData={potDetails}
                        index={i}
                        checked={checked}
                        disabled={potDisabled}
                        savingId={this.props.data.id}
                        onClick={this.potClick}
                        name={this.props.name}
                      />
                    );
                  })}
              </div>
            </div>
          )}

          <div className="c-radio c-radio__movemoney">
            <div className="c-radio__vertical radio">
              {this.props.name !== StringConstant.toList ||
              (this.props.name === StringConstant.toList && isRegig) ? (
                <SavingPotAvailable
                  data={this.props.data}
                  name={this.props.name}
                  onClick={this.potAvailableClick}
                />
              ) : (
                ''
              )}
            </div>
          </div>
        </div>
        <div className="account-card__continue">
          <Button
            btnName="Continue"
            className="c-btn c-btn--link"
            onClick={this.continueClick}
            disabled={disabled}
          />
        </div>
      </Panel>
    );
  }

  // PS2
  tosavingpotClick() {
    SavingsPotsStore.getMoveMoneyAccountIndex(this.props.data.id);
    SavingPotsActionCreator.saveNavigationReference('WEB-OPEN-MOVEMONEY');
    InternetBankingActions.navigateToWebTask('WEB-OPEN-SAVING-POTS');
  }

  renderPanel() {
    let componentName;
    let componentData;
    let account = this.props.data;
    const savingClassName = cx({
      'account-card': true,
      'account-card--inactive': this.isAccountInActive(), // What is inactive in css
    });

    let panelContent = '';
    // if (this.state.continueActive) {
    //     panelContent = this.showSavingPotPanel();
    // }
    if (this.props.potOpen) {
      panelContent = this.showSavingPotPanel();
    }

    if (!BrowserUtils.isMobileView()) {
      // For Desktop
      if (MoveMoneyBL.getAccountNickname(account)) {
        componentName = 'componentA'; // with nickname available
      } else {
        componentName = 'componentB'; // without nickname
      }
    } else {
      // For Mobile
      if (MoveMoneyBL.getAccountNickname(account)) {
        componentName = 'componentC'; // with nickname available
      } else {
        componentName = 'componentD'; // without nickname
      }
    }

    switch (componentName) {
      case 'componentA':
        componentData = (
          <li
            role="option"
            className={savingClassName}
            tabIndex="0"
            onClick={this.onClick}
            ref={`cardItem${this.props.index}`}
            onKeyDown={this.checkKeyPress}
          >
            <div
              className="card-to-top"
              id={`cardItem${this.props.index}${this.props.name}`}
              name={`cardItem${this.props.index}${this.props.name}`}
            >
              .
            </div>
            <a
              className="account-card__link"
              aria-hidden="true"
              tabIndex="-1"
              href="javascript:void(0);"
            >
              <SelectedAccountComponent
                componentName={componentName}
                selectedAccount={this.props.data}
              />
            </a>
            {panelContent}
          </li>
        );
        break;

      case 'componentB':
        componentData = (
          <li
            role="option"
            className={savingClassName}
            tabIndex="0"
            onClick={this.onClick}
            ref={`cardItem${this.props.index}`}
            onKeyDown={this.checkKeyPress}
          >
            <span>{this.props.potOpen}</span>
            <div
              className="card-to-top"
              id={`cardItem${this.props.index}${this.props.name}`}
              name={`cardItem${this.props.index}${this.props.name}`}
            >
              .
            </div>
            <a
              className="account-card__link"
              aria-hidden="true"
              tabIndex="-1"
              href="javascript:void(0);"
            >
              <SelectedAccountComponent
                componentName={componentName}
                selectedAccount={this.props.data}
              />
            </a>
            {panelContent}
          </li>
        );
        break;

      case 'componentC':
        componentData = (
          <li
            role="option"
            className={savingClassName}
            tabIndex="0"
            onClick={this.onClick}
            ref={`cardItem${this.props.index}`}
            role="menuitem"
            onKeyDown={this.checkKeyPress}
          >
            <div
              className="card-to-top"
              id={`cardItem${this.props.index}${this.props.name}`}
              name={`cardItem${this.props.index}${this.props.name}`}
            >
              .
            </div>
            <a
              className="account-card__link"
              aria-hidden="true"
              tabIndex="-1"
              href="javascript:void(0);"
            >
              <SelectedAccountComponent
                componentName="componentA"
                selectedAccount={this.props.data}
              />
            </a>
            {panelContent}
          </li>
        );
        break;

      case 'componentD':
        componentData = (
          <li
            role="option"
            className={savingClassName}
            tabIndex="0"
            onClick={this.onClick}
            ref={`cardItem${this.props.index}`}
            onKeyDown={this.checkKeyPress}
          >
            <div
              className="card-to-top"
              id={`cardItem${this.props.index}${this.props.name}`}
              name={`cardItem${this.props.index}${this.props.name}`}
            >
              .
            </div>
            <a
              className="account-card__link"
              aria-hidden="true"
              tabIndex="-1"
              href="javascript:void(0);"
            >
              <SelectedAccountComponent
                componentName="componentB"
                selectedAccount={this.props.data}
              />
            </a>
            {panelContent}
          </li>
        );
        break;
    }
    return componentData;
  }

  render() {
    return this.renderPanel();
  }
}

SavingComponent.propTypes = {
  content: PropTypes.object,
  data: PropTypes.object, // account details
  name: PropTypes.string,
  potOpen: PropTypes.bool,
  fromSelectedPot: PropTypes.object, // selected Pot details
  fromAvailablePot: PropTypes.object,
  toSelectedPot: PropTypes.object,
  index: PropTypes.number,
};

SavingComponent.defaultProps = {
  content: '',
  data: {},
  name: '',
  potOpen: false,
  fromSelectedPot: {},
  toSelectedPot: {},
  index: 0,
};

export default SavingComponent;
